import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfilePage from './ProfilePage';

const PublicProfileSlugPage = () => {
  const { profileSlug } = useParams();
  const location = useLocation();
  const [showGateModal, setShowGateModal] = useState(false);

  const fromPath = useMemo(() => location.pathname, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = showGateModal ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [showGateModal]);

  const openGate = () => setShowGateModal(true);

  return (
    <div className="min-h-screen bg-gray-50">
      <ProfilePage
        forcedReadOnly
        publicSlugOverride={profileSlug}
        onAuthAction={openGate}
      />

      {showGateModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6 text-center">
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Sign in to continue</h2>
            <p className="text-sm text-gray-600 mb-6">
              Sign in or join to connect or send a message.
            </p>
            <div className="flex items-center justify-center gap-3">
              <Link to="/login" state={{ from: fromPath }} className="btn btn-primary">
                Sign In
              </Link>
              <Link to="/register" state={{ from: fromPath }} className="btn btn-outline">
                Join Now
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicProfileSlugPage;
